// Core React Imports
import React, { createContext, useContext } from "react";
import { useWidgetLoading } from "./useWidgetLoading";

// CSS/Stylesheets
import "./WidgetLoading.css";

// Create a context for loading state
const LoadingContext = createContext();

// Create a provider component
export const WidgetLoading = ({ children }) => {
  const { isLoading, showLoading, hideLoading } = useWidgetLoading();

  return (
    <LoadingContext.Provider value={{ isLoading, showLoading, hideLoading }}>
      {children}
      {isLoading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}
    </LoadingContext.Provider>
  );
};

// Custom hook to use the loading context
export const useLoading = () => useContext(LoadingContext);
